import type { OnboardingProfileSectionFields } from '@pharmaplan/common';
import * as Yup from 'yup';

import {
  ContactValidator,
  GeneralValidator,
  ProfessionalValidator,
} from '../PharmacistSignupFlow/Validator';

const getValidationErrors = async (
  schema: Yup.Schema<unknown>,
  values: unknown,
) => {
  try {
    await schema.validate(values, { abortEarly: false });
    return [];
  } catch (error) {
    if (!(error instanceof Yup.ValidationError)) {
      throw error;
    }

    const errors = error.inner.length > 0 ? error.inner : [error];
    return errors.map(({ message, path }) =>
      `${path ?? 'input'}: ${message}`);
  }
};

export const validateManualProfessionalProfile = async (
  profile: OnboardingProfileSectionFields,
) => {
  const manualProfile = {
    ...profile,
    image: 'ai-onboarding',
    pharmacistCapacityId: profile.professionalCapacityId,
  };
  const schemas = [
    GeneralValidator(),
    ProfessionalValidator(),
    ContactValidator(),
  ];
  const validationErrors = await Promise.all(
    schemas.map((schema) =>
      getValidationErrors(schema, manualProfile)),
  );

  return validationErrors.flat();
};
